import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {TranslateModule} from '@ngx-translate/core';
import {PipesModule} from 'src/app/pipes/pipe.module';
import {Notification} from './notification.modal';
@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, PipesModule, TranslateModule],
    declarations: [Notification],
})
export class NotificationModalModule {}
